import { commonUtils } from '@sato/components';
import * as yup from 'yup';

import { api } from '@api';
import { useIncidentCreation } from '@hooks/incidents';
import { DisturbanceReason } from '@models/api/Incident';
import { t } from '@stores/localization';

export type DisturbedAreas = 'COMMON' | 'APARTMENT' | 'OTHER';

const defaultInitialValues: Partial<DisturbanceReportFormBase> = {
  disturbanceTimes: undefined,
  discussed: undefined,
  policeCalled: undefined,
  reportedBefore: undefined,
  disturbancePerson: '',
  disturbanceReason: undefined,
  description: '',
};

const defaultValidationSchema: yup.ObjectSchema<DisturbanceReportFormBase> = yup
  .object()
  .shape({
    disturbanceTimes: yup
      .array()
      // Filter out null times to handle DateTimePicker implementation detail where newly added dates are null
      .transform((value: Array<Date | null>) =>
        value?.filter(commonUtils.nonNullable)
      )
      .min(1, () => t('error.required_field'))
      .required(),
    disturbancePerson: yup.string(),
    discussed: yup.boolean().required(),
    policeCalled: yup.boolean().required(),
    reportedBefore: yup.boolean().required(),
    disturbanceReason: yup
      .string()
      .oneOf(Object.values(DisturbanceReason))
      .required(),
    description: yup.string().required(),
  });

export type DisturbanceReportFormBase = {
  description: string;
  discussed: boolean;
  policeCalled: boolean;
  reportedBefore: boolean;
  disturbanceTimes: Date[];
  disturbanceReason: DisturbanceReason;
  disturbancePerson?: string;
};

export const useDisturbanceReport = () => {
  const { create } = useIncidentCreation({
    postIncident: api.incidents.postDisturbanceIncident,
  });

  return {
    create,
    defaultInitialValues,
    defaultValidationSchema,
  };
};
